/*
  Campaign form: main fields first, the rest under "Additional settings".
  Merged FIRST into TRANSLATION_MAPS in ./index.js, so existing translations
  still win. Keys are the English source.
*/

const ru = {
  "Additional settings": "Дополнительные настройки",
  "Description, group, cost, click ID parameter, privacy, redirect mode, uniqueness and cloaking. The defaults work for most campaigns.": "Описание, группа, стоимость, параметр click ID, приватность, режим перехода, уникальность и маскировка. Значения по умолчанию подходят большинству кампаний.",
};

const es = {
  "Additional settings": "Ajustes adicionales",
  "Description, group, cost, click ID parameter, privacy, redirect mode, uniqueness and cloaking. The defaults work for most campaigns.": "Descripción, grupo, coste, parámetro de click ID, privacidad, modo de redirección, unicidad y cloaking. Los valores predeterminados sirven para la mayoría de las campañas.",
};

const pt = {
  "Additional settings": "Configurações adicionais",
  "Description, group, cost, click ID parameter, privacy, redirect mode, uniqueness and cloaking. The defaults work for most campaigns.": "Descrição, grupo, custo, parâmetro de click ID, privacidade, modo de redirecionamento, unicidade e cloaking. Os valores padrão servem para a maioria das campanhas.",
};

const de = {
  "Additional settings": "Weitere Einstellungen",
  "Description, group, cost, click ID parameter, privacy, redirect mode, uniqueness and cloaking. The defaults work for most campaigns.": "Beschreibung, Gruppe, Kosten, Click-ID-Parameter, Datenschutz, Weiterleitungsmodus, Eindeutigkeit und Cloaking. Die Standardwerte passen für die meisten Kampagnen.",
};

const fr = {
  "Additional settings": "Paramètres supplémentaires",
  "Description, group, cost, click ID parameter, privacy, redirect mode, uniqueness and cloaking. The defaults work for most campaigns.": "Description, groupe, coût, paramètre de click ID, confidentialité, mode de redirection, unicité et cloaking. Les valeurs par défaut conviennent à la plupart des campagnes.",
};

const it = {
  "Additional settings": "Impostazioni aggiuntive",
  "Description, group, cost, click ID parameter, privacy, redirect mode, uniqueness and cloaking. The defaults work for most campaigns.": "Descrizione, gruppo, costo, parametro click ID, privacy, modalità di reindirizzamento, unicità e cloaking. I valori predefiniti vanno bene per la maggior parte delle campagne.",
};

const pl = {
  "Additional settings": "Dodatkowe ustawienia",
  "Description, group, cost, click ID parameter, privacy, redirect mode, uniqueness and cloaking. The defaults work for most campaigns.": "Opis, grupa, koszt, parametr click ID, prywatność, tryb przekierowania, unikalność i cloaking. Wartości domyślne pasują do większości kampanii.",
};

const tr = {
  "Additional settings": "Ek ayarlar",
  "Description, group, cost, click ID parameter, privacy, redirect mode, uniqueness and cloaking. The defaults work for most campaigns.": "Açıklama, grup, maliyet, click ID parametresi, gizlilik, yönlendirme modu, benzersizlik ve cloaking. Varsayılan değerler çoğu kampanya için uygundur.",
};

const uk = {
  "Additional settings": "Додаткові налаштування",
  "Description, group, cost, click ID parameter, privacy, redirect mode, uniqueness and cloaking. The defaults work for most campaigns.": "Опис, група, вартість, параметр click ID, приватність, режим переходу, унікальність і маскування. Значення за замовчуванням підходять більшості кампаній.",
};

const CAMPAIGN_FORM = { ru, es, pt, de, fr, it, pl, tr, uk };
export default CAMPAIGN_FORM;
